var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "newVue" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "text-xs-center" },
          [
            _c("v-progress-circular", {
              staticClass: "primary--text",
              attrs: { indeterminate: "", size: 100, width: 1 }
            })
          ],
          1
        )
      : _c(
          "div",
          [
            _c("v-subheader", [
              _vm._v(
                _vm._s(
                  _vm.$tc("sites", _vm.sites.length, {
                    count: _vm.sites.length
                  }) +
                    " (" +
                    _vm.$store.state._User.entNbSite +
                    " max)"
                )
              )
            ]),
            _vm._v(" "),
            _c(
              "v-expansion-panel",
              _vm._l(_vm.sites, function(site, i) {
                return _c(
                  "v-expansion-panel-content",
                  { key: i },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _vm._v(_vm._s(site.name) + " "),
                      _c("code", [_vm._v(_vm._s(site.url))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-card-text",
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm3: "" } },
                                  [
                                    _c("v-switch", {
                                      attrs: {
                                        label: site.isValid
                                          ? "Le site est activé"
                                          : "Le site est désactivé",
                                        color: "primary",
                                        disabled: site.isValid
                                      },
                                      model: {
                                        value: site.isValid,
                                        callback: function($$v) {
                                          _vm.$set(site, "isValid", $$v)
                                        },
                                        expression: "site.isValid"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm3: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: _vm._f("cap")(_vm.$t("name"))
                                      },
                                      model: {
                                        value: site.name,
                                        callback: function($$v) {
                                          _vm.$set(site, "name", $$v)
                                        },
                                        expression: "site.name"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm3: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: { label: "URL" },
                                      model: {
                                        value: site.url,
                                        callback: function($$v) {
                                          _vm.$set(site, "url", $$v)
                                        },
                                        expression: "site.url"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm3: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: _vm._f("cap")(
                                          _vm.$t("contactEmail")
                                        )
                                      },
                                      model: {
                                        value: site.contact,
                                        callback: function($$v) {
                                          _vm.$set(site, "contact", $$v)
                                        },
                                        expression: "site.contact"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm3: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: _vm._f("cap")(
                                          _vm.$t("copyEmail") +
                                            " " +
                                            _vm.$t("separatedSemiColon")
                                        )
                                      },
                                      model: {
                                        value: site.copii,
                                        callback: function($$v) {
                                          _vm.$set(site, "copii", $$v)
                                        },
                                        expression: "site.copii"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm3: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        disabled: "",
                                        label: _vm._f("cap")(
                                          _vm.$t("phone") +
                                            " (" +
                                            _vm.$t("callback") +
                                            ")"
                                        )
                                      },
                                      model: {
                                        value: site.phone,
                                        callback: function($$v) {
                                          _vm.$set(site, "phone", $$v)
                                        },
                                        expression: "site.phone"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [_c("v-flex", { attrs: { xs12: "", sm3: "" } })],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm3: "" } },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.language,
                                        label: _vm._f("cap")(
                                          _vm.$t("language")
                                        ),
                                        "menu-props": "auto"
                                      },
                                      model: {
                                        value: site.lang,
                                        callback: function($$v) {
                                          _vm.$set(site, "lang", $$v)
                                        },
                                        expression: "site.lang"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm3: "" } },
                                  [
                                    _c("v-subheader", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("cap")(
                                            _vm.$tc(
                                              "agents",
                                              site.agentMapped.length,
                                              { count: site.agentMapped.length }
                                            )
                                          )
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                [
                                  _c(
                                    "v-container",
                                    {
                                      staticClass: "pa-0",
                                      attrs: { fluid: "" }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        _vm._l(site.agentMapped, function(
                                          agent,
                                          j
                                        ) {
                                          return _c(
                                            "v-flex",
                                            {
                                              key: j,
                                              attrs: { md12: "", sm12: "" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-xs-left ma-2"
                                                },
                                                [
                                                  _c(
                                                    "v-chip",
                                                    {
                                                      staticClass:
                                                        "indigo white--text"
                                                    },
                                                    [
                                                      _c("v-avatar", [
                                                        _c("img", {
                                                          attrs: {
                                                            src: agent.avatar,
                                                            alt: ""
                                                          }
                                                        })
                                                      ]),
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(agent.text) +
                                                          "\n                        "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-xs-right" },
              [
                _vm.canAdd
                  ? _c(
                      "v-fab-transition",
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "secondary",
                            attrs: { dark: "", fab: "" },
                            nativeOn: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.openDialogCreate.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("add")])],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-dialog",
              {
                attrs: { persistent: "", "max-width": "320" },
                model: {
                  value: _vm.showDialogCreate,
                  callback: function($$v) {
                    _vm.showDialogCreate = $$v
                  },
                  expression: "showDialogCreate"
                }
              },
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-title",
                      { staticClass: "primary white--text" },
                      [
                        _c("v-icon", { attrs: { dark: "" } }, [
                          _vm._v("language")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "title pl-2" }, [
                          _vm._v(
                            _vm._s(_vm._f("cap")(_vm.$t("add"))) +
                              " " +
                              _vm._s(_vm.$tc("sites", 1, { count: 1 }))
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-card-text",
                      [
                        _c("v-text-field", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "max:32",
                              expression: "'max:32'"
                            }
                          ],
                          attrs: {
                            autofocus: "",
                            label: _vm._f("cap")(_vm.$t("name")),
                            counter: "",
                            max: "32",
                            "data-vv-name": "newSiteName"
                          },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.submitDialogCreate.apply(
                                null,
                                arguments
                              )
                            }
                          },
                          model: {
                            value: _vm.newSiteDialog.name,
                            callback: function($$v) {
                              _vm.$set(_vm.newSiteDialog, "name", $$v)
                            },
                            expression: "newSiteDialog.name"
                          }
                        }),
                        _vm._v(" "),
                        _c("v-text-field", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|max:255",
                              expression: "'required|max:255'"
                            }
                          ],
                          attrs: {
                            autofocus: "",
                            label: "URL",
                            counter: "",
                            max: "255",
                            required: "",
                            "data-vv-name": "newSiteUrl"
                          },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.submitDialogCreate.apply(
                                null,
                                arguments
                              )
                            }
                          },
                          model: {
                            value: _vm.newSiteDialog.url,
                            callback: function($$v) {
                              _vm.$set(_vm.newSiteDialog, "url", $$v)
                            },
                            expression: "newSiteDialog.url"
                          }
                        }),
                        _vm._v(" "),
                        _c("v-switch", {
                          attrs: {
                            label: _vm._f("cap")(_vm.$t("enabled") + "?"),
                            color: "primary"
                          },
                          model: {
                            value: _vm.newSiteDialog.activated,
                            callback: function($$v) {
                              _vm.$set(_vm.newSiteDialog, "activated", $$v)
                            },
                            expression: "newSiteDialog.activated"
                          }
                        }),
                        _vm._v(" "),
                        _c("v-switch", {
                          attrs: {
                            label: _vm.$t("associateAllAgents"),
                            color: "primary"
                          },
                          model: {
                            value: _vm.newSiteDialog.allAgents,
                            callback: function($$v) {
                              _vm.$set(_vm.newSiteDialog, "allAgents", $$v)
                            },
                            expression: "newSiteDialog.allAgents"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-card-actions",
                      [
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { flat: "" },
                            nativeOn: {
                              click: function($event) {
                                _vm.showDialogCreate = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("cancel")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "primary", flat: "" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.submitDialogCreate.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("submit")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-xs-right" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "primary",
                      fixed: "",
                      bottom: "",
                      right: ""
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.submit.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm._f("cap")(_vm.$t("save")))
                    ),
                    _c("v-icon", { attrs: { dark: "", right: "" } }, [
                      _vm._v("send")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4409c5a0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4409c5a0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/management/Sites.vue
// module id = null
// module chunks = 